import { render } from "./Chip.vue?vue&type=template&id=d5c84e9c"
import script from "./Chip.vue?vue&type=script&lang=js"
export * from "./Chip.vue?vue&type=script&lang=js"
script.render = render

export default script